export default __webpack_public_path__ + "images/linechart.3c587624224dedcbe004420407b309c5.svg";